import { render, staticRenderFns } from "./product-log-v2.modal.vue?vue&type=template&id=2ec82dfe&scoped=true"
import script from "./product-log-v2.modal.vue?vue&type=script&lang=js"
export * from "./product-log-v2.modal.vue?vue&type=script&lang=js"
import style0 from "./product-log-v2.modal.vue?vue&type=style&index=0&id=2ec82dfe&prod&lang=scss&scoped=true"
import style1 from "./product-log-v2.modal.vue?vue&type=style&index=1&id=2ec82dfe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec82dfe",
  null
  
)

export default component.exports